/**
 * Set referrer in url on if the referrer is not the same as the current domain
 * @returns void
 */
const useSetReferrerInUrl = () => {
  const referrer = document.referrer
  if (!referrer) {
    return
  }

  const referrerUrl = new URL(referrer)
  const referrerDomain = referrerUrl.hostname

  const currentDomain = window.location.hostname
  const currentUrl = new URL(window.location.href)

  if (referrerDomain !== currentDomain) {
    currentUrl.searchParams.set('referrer', referrerUrl.href)
    window.history.replaceState({}, '', currentUrl.toString())
  }
}

export default useSetReferrerInUrl
